function slider () {
    /*=======
    Athletes slider
    =======*/
    const athletesSlider = document.querySelector('.athletes-slider');

    if(athletesSlider) {
        let slider = new Swiper(athletesSlider, {
            loop: true,
            speed: 1200,
            spaceBetween: 100,
            // autoplay: {
            //     delay: 3000,
            //     disableOnInteraction: false,
            //     pauseOnMouseEnter: true,
            // },
            navigation: {
                nextEl: ".slider-athletes__button--prev",
                prevEl: ".slider-athletes__button--next",
            },
        });
    }


    /*=======
    Welcome slider
    =======*/
    const welcomeSlider = document.querySelector('.welcome__news-slider');

    if(welcomeSlider) {
        let slider = new Swiper(welcomeSlider, {
            speed: 600,
            spaceBetween: 20,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            breakpoints: {
                1: {
                  slidesPerView: 1,
                  loop: true,
                },
                768: {
                  slidesPerView: 3,
                  loop: false,
                },
            },
            pagination: {
                el: ".welcome__news-pagination",
                clickable: true,
            },
        });
    }
}

export default slider;